// Downloaded report file names (FIG-345 · UC-232, REQ-052; DECIDED 20 Oct):
//   YYYYMMDD_[merchant]_ReportName.csv, dated to the day the data runs to.
// The Merchant acronym (REQ-052) doesn't exist yet, so the merchant part is a
// cleaned-up organisation name; switch to the acronym once it is built.
import { TEST_NAME_PREFIX } from './merchantStatus';

const REPORT_FILE_NAMES: Record<string, string> = {
  skus: 'Variants',
  'sales-history': 'SalesHistory',
  'fixed-costs': 'FixedCosts',
};

/**
 * Clean-up rule (DECIDED 20 Oct): remove the [TEST] prefix; keep letters and
 * numbers; turn spaces and runs of other characters into one underscore; trim
 * underscores from the ends. "Quill & Co." → "Quill_Co".
 */
export function cleanMerchantFileName(name: string | null | undefined): string {
  const withoutTest = (name ?? '').trimStart().startsWith(TEST_NAME_PREFIX)
    ? (name ?? '').trimStart().slice(TEST_NAME_PREFIX.length)
    : (name ?? '');
  const cleaned = withoutTest.replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  return cleaned || 'Merchant';
}

/** YYYYMMDD of a date, in UTC (the reports' "today" is the UTC day). */
export function fileDateStamp(date: Date): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}

export function reportFileName(options: {
  merchantName: string | null | undefined;
  reportType: string | null | undefined;
  /** The day the data runs to. */
  dataDate: Date;
}): string {
  const report = REPORT_FILE_NAMES[options.reportType ?? ''] ?? 'Report';
  return `${fileDateStamp(options.dataDate)}_${cleanMerchantFileName(options.merchantName)}_${report}.csv`;
}
